import ToastHighLighter from '@/lib/ToastHighLighter';

export const CookieHtmlCode = () => {
  const language = 'html';
  const codeString = `
  // Cookiebanner
  
  <!-- START Bootstrap-Cookie-Alert -->
  <div class="alert alert-secondary cookiealert" role="alert" aria-label="Datenschutz und Cookies" aria-hidden="false">
      <div class="container">
          <div class="row">
              <div class="col-10">
                  <p>Indem Sie diesen Hinweis schliessen oder mit dem Besuch der Seite fortfahren, akzeptieren Sie die
                      Verwendung von Cookies. Weitere Informationen dazu finden Sie unter
                      <a href="https://www.fhnw.ch/de/impressum/datenschutz" target="_blank">Datenschutz</a>.
                  </p>
              </div>
              <div class="col-2 mt-3">
                  <button type="button" class="btn btn-secondary btn-sm acceptcookies float-right pl-3 pr-3"
                      aria-label="Schliessen">
                      Ok
                  </button>
              </div>
          </div>
      </div>
  </div>
  <!-- END Bootstrap-Cookie-Alert -->
`;

  return (
    <>
      <ToastHighLighter
        name={'navigationtabs'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};
